import { fromPromise } from "xstate";
import type {
  CheckoutGateway,
  PaymentCollectionInput,
  PaymentCollectionResult,
} from "./contracts";
import { CheckoutActorError } from "./contracts";
import { runCheckoutActor } from "./timeout";

export interface PaymentActorInput extends PaymentCollectionInput {
  gateway: CheckoutGateway;
}

export const paymentActor = fromPromise<
  PaymentCollectionResult,
  PaymentActorInput
>(async ({ input, signal }) => {
  if (!input.gateway.collectPayment) {
    throw new CheckoutActorError({
      code: "unavailable",
      message: "Payment collection is unavailable",
      retryable: false,
    });
  }
  return runCheckoutActor(signal, (derivedSignal) =>
    input.gateway.collectPayment!({
      runtime: input.runtime,
      intent: input.intent,
      paymentOptionKey: input.paymentOptionKey,
      signal: derivedSignal,
    }),
  );
});
